//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateSaldoCuentas } from "@/typings/store/plugins/easyFirestore/saldoCuentas";

const getters: GetterTree<StateSaldoCuentas, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const saldoCuentas = {
    firestorePath: "dev/v1/saldoCuentas",
    firestoreRefType: "collection",
    moduleName: "saldoCuentas",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default saldoCuentas;
